import StudentSurveyListPage from "./StudentSurveyListPage";

export default StudentSurveyListPage